import yn from 'yn';

import { LogLevel } from '@azure/msal-browser';

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig = {
  auth: {
    clientId: process.env.CLIENT_AAD_APP_CLIENT_ID,
    authority: process.env.CLIENT_AAD_APP_AUTHORITY,
    redirectUri: process.env.CLIENT_AAD_APP_REDIRECT_URI,
    // navigateToLoginRequestUrl: false, // If "true", will navigate back to the original request location before processing the auth code response.
  },
  cache: {
    cacheLocation: 'sessionStorage', // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;

        if (!yn(process.env.VERBOSE)) {
          return;
        }

        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            console.warn(`Unknown log level ${level}.`);
        }
      },
    },
  },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
  scopes: ['User.Read'],
};

export const logoutRequest = {
  postLogoutRedirectUri: '/',
};

export const protectedResources = {
  GraphMe: {
    endpoint: 'https://graph.microsoft.com/v1.0/me',
    scopes: ['User.Read'],
  },
  GetUser: {
    endpoint: '/api/GetUser',
    scopes: [
      `${process.env.API_AAD_APP_APPLICATION_ID_URI}/${process.env.API_AAD_APP_READ_SCOPE}`,
    ],
  },
  GetGraphql: {
    endpoint: '/api/graph',
    scopes: [
      `${process.env.API_AAD_APP_APPLICATION_ID_URI}/${process.env.API_AAD_APP_READWRITE_SCOPE}`,
    ],
  },
};
